import React, { useState } from "react";
import { toast } from "react-toastify";

const VCLeaderboard = () => {
  const [filterPanelVisible, setFilterPanelVisible] = useState(false);
  const [modalData, setModalData] = useState(null);

  const toggleFilters = () => {
    setFilterPanelVisible(!filterPanelVisible);
  };

  const openModal = (data) => {
    setModalData(data);
  };

  const closeModal = () => {
    setModalData(null);
  };

  const exportData = () => {
    toast.info("Exporting data...", { autoClose: 3000 });
  };

  return (
    <div
      style={{
        fontFamily: "Poppins, sans-serif",
        backgroundColor: "#eaedf2",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h1 style={{ fontSize: "24px", fontWeight: "600" }}>
          VC Performance Leaderboard
        </h1>
        <nav style={{ color: "#555" }}>
          <span>Dashboard</span> &gt;{" "}
          <span style={{ fontWeight: "600" }}>VC Performance Leaderboard</span>
        </nav>
        <div style={{ color: "#555" }}>Last Updated: 12:00 PM</div>
        <button
          style={{
            backgroundColor: "#e0e0e0",
            color: "#333",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
          }}
          onClick={toggleFilters}
        >
          Filters <i className="fas fa-filter"></i>
        </button>
      </header>

      {/* Filters Panel */}
      {filterPanelVisible && (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            marginBottom: "20px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "10px",
            }}
          >
            <select
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option>State</option>
              <option>State 1</option>
              <option>State 2</option>
            </select>
            <select
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option>District</option>
            </select>
            <select
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option>Task Type</option>
              <option>Guest Lectures</option>
              <option>Industry Visits</option>
            </select>
            <input
              type="date"
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
            <input
              type="range"
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
              min="0"
              max="100"
              defaultValue="60"
            />
            <select
              style={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option>Rank View</option>
              <option>Top 10</option>
              <option>Top 20</option>
              <option>Bottom 10</option>
              <option>All</option>
            </select>
          </div>
          <div style={{ marginTop: "20px" }}>
            <button
              style={{
                backgroundColor: "#007BFF",
                color: "#fff",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                marginRight: "10px",
              }}
            >
              Apply Filters
            </button>
            <button
              style={{
                backgroundColor: "#e0e0e0",
                color: "#333",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
              }}
            >
              Reset Filters
            </button>
          </div>
        </div>
      )}

      {/* Leaderboard Metrics */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Total VCs Tracked
          </h2>
          <p style={{ fontSize: "20px", fontWeight: "700", color: "#007BFF" }}>
            50
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Average Performance Score
          </h2>
          <p style={{ fontSize: "20px", fontWeight: "700", color: "#28a745" }}>
            85%
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Top-Performing Task Type
          </h2>
          <p style={{ fontSize: "20px", fontWeight: "700", color: "#333" }}>
            Guest Lectures
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Highest Ranked VC
          </h2>
          <p style={{ fontSize: "20px", fontWeight: "700", color: "#FFC107" }}>
            John Doe
          </p>
          <p style={{ fontSize: "16px" , marginTop:"-20px"}}>Score: 95%</p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Lowest Ranked VC
          </h2>
          <p style={{ fontSize: "20px", fontWeight: "700", color: "red" }}>
            Jane Smith
          </p>
          <p style={{ fontSize: "16px",marginTop:"-20px" }}>Score: 60%</p>
        </div>
      </div>

      {/* Table */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          overflow: "hidden",
          marginBottom: "20px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <table style={{ width: "100%" }}>
          <thead style={{ backgroundColor: "#f0f0f0" }}>
            <tr>
              <th style={{ padding: "10px" }}>Rank</th>
              <th style={{ padding: "10px" }}>VC Name</th>
              <th style={{ padding: "10px" }}>State</th>
              <th style={{ padding: "10px" }}>District</th>
              <th style={{ padding: "10px" }}>Total Tasks</th>
              <th style={{ padding: "10px" }}>On-Time %</th>
              <th style={{ padding: "10px" }}>Delayed %</th>
              <th style={{ padding: "10px" }}>Performance Score</th>
              <th style={{ padding: "10px" }}>Top Task Type</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onClick={() =>
                openModal({
                  name: "John Doe",
                  location: "California",
                  score: 95,
                })
              }
            >
              <td style={{ padding: "10px" }}>1</td>
              <td style={{ padding: "10px" }}>John Doe</td>
              <td style={{ padding: "10px" }}>California</td>
              <td style={{ padding: "10px" }}>Los Angeles</td>
              <td style={{ padding: "10px" }}>35</td>
              <td style={{ padding: "10px" }}>90%</td>
              <td style={{ padding: "10px" }}>10%</td>
              <td style={{ padding: "10px", color: "#28a745" }}>95%</td>
              <td style={{ padding: "10px" }}>Guest Lectures</td>
            </tr>
            <tr
              style={{
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onClick={() =>
                openModal({
                  name: "John Doe",
                  location: "California",
                  score: 95,
                })
              }
            >
              <td style={{ padding: "10px" }}>1</td>
              <td style={{ padding: "10px" }}>John Doe</td>
              <td style={{ padding: "10px" }}>California</td>
              <td style={{ padding: "10px" }}>Los Angeles</td>
              <td style={{ padding: "10px" }}>35</td>
              <td style={{ padding: "10px" }}>90%</td>
              <td style={{ padding: "10px" }}>10%</td>
              <td style={{ padding: "10px", color: "#28a745" }}>95%</td>
              <td style={{ padding: "10px" }}>Guest Lectures</td>
            </tr>
            <tr
              style={{
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onClick={() =>
                openModal({
                  name: "John Doe",
                  location: "California",
                  score: 95,
                })
              }
            >
              <td style={{ padding: "10px" }}>1</td>
              <td style={{ padding: "10px" }}>John Doe</td>
              <td style={{ padding: "10px" }}>California</td>
              <td style={{ padding: "10px" }}>Los Angeles</td>
              <td style={{ padding: "10px" }}>35</td>
              <td style={{ padding: "10px" }}>90%</td>
              <td style={{ padding: "10px" }}>10%</td>
              <td style={{ padding: "10px", color: "#28a745" }}>95%</td>
              <td style={{ padding: "10px" }}>Guest Lectures</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modalData && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "500px",
            }}
          >
            <h2 style={{ fontSize: "24px", fontWeight: "600" }}>
              {modalData.name}
            </h2>
            <p>Location: {modalData.location}</p>
            <p>Performance Score: {modalData.score}%</p>
            <button
              style={{
                backgroundColor: "#007BFF",
                color: "#fff",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                marginRight: "10px",
              }}
              onClick={exportData}
            >
              Export Data
            </button>
            <button
              style={{
                backgroundColor: "#e0e0e0",
                color: "#333",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
              }}
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          height: "200px",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        ></div>
      </div>
      <div>
        <button
          style={{
            backgroundColor: "#007BFF",
            color: "#fff",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            marginRight: "10px",
          }}
        >
          Export as CSV
        </button>
        <button
          style={{
            backgroundColor: "#007BFF",
            color: "#fff",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            marginRight: "10px",
          }}
        >
          Export as PDF
        </button>
      </div>
    </div>
  );
};

export default VCLeaderboard;
